import { OPEN_SEA } from "@constants/types";
import urlFieldValidate from "@validators/shared/url.validate";
import { t } from "i18next";
import emptyFieldValidate from "../../../shared/empty.validate";
import priceValidate from "../../../shared/price.validate";

export type TErrors = {
  url: string | undefined;
  title: string | undefined;
  pageLink: string | undefined;
  pieceLink: string | undefined;
  order: string | undefined;
  releaseDate: string | undefined;
  edition: string | undefined;
  price: string | undefined;
};

const NftModifyValidate = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    url: undefined,
    title: undefined,
    pageLink: undefined,
    pieceLink: undefined,
    order: undefined,
    releaseDate: undefined,
    edition: undefined,
    price: undefined,
  };
  const isOpenSea = FormValues?.type === OPEN_SEA;

  errors.title = isOpenSea
    ? undefined
    : emptyFieldValidate(FormValues.title, t("core:common:title"));

  errors.pageLink = isOpenSea
    ? undefined
    : urlFieldValidate(
        FormValues.pageLink,
        t("core:common:page_link"),
        !isOpenSea
      );

  errors.pieceLink = isOpenSea
    ? undefined
    : urlFieldValidate(
        FormValues.pieceLink,
        t("core:common:piece_link"),
        !isOpenSea
      );

  errors.order = emptyFieldValidate(FormValues.order, t("core:common:order"));
  errors.edition = emptyFieldValidate(
    FormValues.edition,
    t("core:common:edition")
  );
  errors.price = priceValidate(FormValues.price);

  return errors;
};

export default NftModifyValidate;
